import { ROLE_ACCESS } from '../constant/storage';

export const checkIsUserJoined = (role: ROLE_ACCESS | undefined) => {
  if (!role) return false;
  return [ROLE_ACCESS.Editor, ROLE_ACCESS.Owner, ROLE_ACCESS.Viewer].includes(
    role
  );
};
